import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';
import { take } from 'rxjs/operators';
import { StatusOption } from 'app/services/borrower-status/status-options';
import { Observable } from 'rxjs';
import { BorrowerStatusReasonDialogComponent } from '../borrower-status-reason-dialog/borrower-status-reason-dialog.component';

interface StatusOptionGroup {
  label: string;
  options: StatusOption[];
}

export interface BorrowerStatusChange {
  status: string;
  reason: string | null;
  dncParams?: {
    isNyState: boolean;
    methods: Array<string>;
  };

}

@Component({
  selector: 'app-borrower-status-picker',
  templateUrl: './borrower-status-picker.component.html',
  styleUrls: ['./borrower-status-picker.component.scss']
})
export class BorrowerStatusPickerComponent implements OnChanges {
  @Input() options: StatusOption[];
  @Input() status: string;
  @Input() disabled: boolean;
  @Input() disabledReason: string;
  @Input() tooltip: string;
  @Output() statusChange = new EventEmitter<BorrowerStatusChange>();

  groups: StatusOptionGroup[];
  selectedOption: StatusOption;
  stageColor = {
    active: '#2F85C3',
    funded: '#83CB97',
    inactive: '#909DA5',
  };

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnChanges(): void {
    this.groups = this.getStatusOptionGroups();
    if (this.options) {
      this.selectedOption = this.options.find(x => x.value === this.status) as StatusOption;
    }
  }

  handleSelectionChange(option: StatusOption) {
    const previousOption = this.selectedOption;
    if (option.value === previousOption.value || option.disabledReason) {
      return false;
    }

    if (option.stage !== 'inactive') {
      this.selectedOption = option;
      this.statusChange.emit({
        status: option.value,
        reason: null
      });
      return;
    }

    // inactive statuses need reason
    this.getReason(option).subscribe( ({reason, dncParams = null}) => {
      if (!reason) {
        // user cancelled
        this.selectedOption = previousOption;
        return;
      }

      this.selectedOption = option;
      this.statusChange.emit({
        status: option.value,
        reason,
        dncParams,
      });
    });
  }

  private getReason(option: StatusOption): Observable<string | null | any> {
    return this.dialog
      .open(BorrowerStatusReasonDialogComponent, {
        data: { selectedOption: option },
        disableClose: true
      })
      .afterClosed()
      .pipe(take(1));
  }

  private getStatusOptionGroups(): StatusOptionGroup[] {
    return _(this.options)
      .groupBy('stage')
      .map((options, label) => ({ label, options }))
      .value();
  }
}
